<template>
	<text-element
		v-model="firstName"
		type="text"
		required
		autocomplete="given-name"
		placeholder="John"
		@keyup.enter="submitHandler"
	/>

	<text-element
		v-model="lastName"
		type="text"
		required
		autocomplete="family-name"
		placeholder="Doe"
		@keyup.enter="submitHandler"
	/>

	<EmailField
		v-model="email"
		:errors="null"
		:show-label="false"
		@keyup:enter="submitHandler"
	/>

	<PasswordField
		v-model="pass"
		:errors="null"
		:show-label="false"
		@keyup:enter="submitHandler"
	/>

	<PasswordField
		v-model="confirmPass"
		:errors="null"
		:show-label="false"
		@keyup:enter="submitHandler"
	/>

	<button
		:disabled="isRegisterDisabled"
		class="
            relative mt-4 flex w-full items-center justify-center
            rounded bg-won-green p-2.5 text-white
            hover:opacity-90 disabled:bg-won-gray disabled:opacity-40
        "
		@click="submitHandler"
	>
		<span
			class="text-white"
			:class="{'opacity-0' : loading}"
		>
			Sign up
		</span>

		<span
			v-if="loading"
			class="absolute"
		>
			<LoadingIcon
				:class="{'opacity-0' : !loading}"
			/>
		</span>
	</button>
</template>

<script setup>
import { shallowRef, computed, toRefs } from 'vue';

import PasswordField from '../password-field.vue';
import EmailField from '../email-field.vue';
import LoadingIcon from '../../../icons/loading-icon.vue';
import TextElement from '../../../forms/elements/text.vue';

const emit = defineEmits(['register']);
const props = defineProps({
	loading: {
		type: Boolean,
		default: false
	}
});

const { loading } = toRefs(props);

const email = shallowRef('');
const pass = shallowRef('');
const confirmPass = shallowRef('');

const firstName = shallowRef('');
const lastName = shallowRef('');

const submitHandler = () => {
	emit('register', {
		email: email.value,
		password: pass.value,
		confirmPassword: confirmPass.value,
		first_name: firstName.value,
		last_name: lastName.value,
	});
};

const isRegisterDisabled = computed(() => {
	return !email.value?.length || loading.value === true
		|| !pass.value?.length
		|| !confirmPass.value?.length;
});
</script>
